import useFileUpload from 'app/functions/useFileUpload'
import DodoneContext from 'app/dodones/Context'
import Spinning from 'app/components/Spinning'

export default ({ dodone, showTextStatus = false }) => {
  const { invalidateQueries } = useContext(DodoneContext);
  const inputRef = useRef(null)
  const selectFile = useCallback(() => {
    if(window.currentIntent && !window.jafoija) {
      cordova.openwith.load(window.currentIntent.items[0], function(data, item) {

        // data is a long base64 string with the content of the file
        uploadFile(item)

        // "exit" when done.
        // Note that there is no need to wait for the upload to finish,
        // the app can continue while in background.
        if (window.currentIntent.exit) {
          cordova.openwith.exit()
          window.currentIntent = null
        }
      })

      window.jafoija = true
      return
    }

    inputRef.current?.click()
  },[dodone])

  const { uploadFile, isPending } = useFileUpload({
    path: `api/dodones/${dodone.id}/upload_proof.json`,
    onComplete: () => {
      return invalidateQueries(dodone.id)
    }
  })

  if(!dodone.isProvable) return null

  let text = dodone.dodoable.name

  if(showTextStatus) {
    if(dodone.isProofStatusPending)
      text = 'Select Proof Video'
    else if(dodone.isProofStatusSaving)
      text = 'Saving...'
    else if(dodone.isProofStatusCompleted)
      text = 'Proved :)'
  }

  return <div className={ `dodone-list-item dodone-list-item-${dodone.proofStatus}` } onClick={ selectFile }>
           {
             (isPending) ?
               <div className="fcol items-center flex-1 mr-d">
                 <Spinning />
               </div> :
               <div className="fcol">
                 <div className="frow">
                   { (dodone.isProofStatusSaving || true) && <div className="mr-d"><Spinning /></div> }
                   <div>{ text }</div>
                   <input ref={ inputRef } type="file" id="video" name="video" hidden="hidden" onChange={ uploadFile } />
                 </div>
                 <div className="text-xs text-gray-500"> { dodone.googleDriveProofFileName } </div>
               </div>
           }
         </div>
}
